export default "__VITE_ASSET__C604td6s__"